import actionTypes from "./seo.type";

export function setSEOData(data) {
  return { type: actionTypes.SET_SEO_DATA, payload: data };
}
